import React, { useState } from "react";
import { HelpCircle } from "lucide-react";
import { trackEvent } from "../../lib/analytics";
import FitmentAssistModal from "./FitmentAssistModal";

/**
 * "Need Help Finding The Correct Part?" CTA. Drop on product, search, and
 * vehicle-results pages. Opens the fitment-assistance modal pre-filled with
 * whatever product/vehicle context is available.
 */
export default function FitmentAssistButton({ prefill = {}, variant = "default", className = "" }) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
    trackEvent("fitment_help_click", {
      product_name: prefill.product_name || undefined,
      product_id: prefill.product_id || undefined,
      vehicle_year: prefill.vehicle_year || undefined,
      vehicle_make: prefill.vehicle_make || undefined,
      vehicle_model: prefill.vehicle_model || undefined,
      source: variant,
    });
    setOpen(true);
  };

  const base = variant === "subtle"
    ? "inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-white border border-white/15 hover:border-white/30 rounded-md px-4 h-11 transition"
    : "inline-flex items-center justify-center gap-2 text-sm text-white bg-white/5 hover:bg-white/10 border border-white/15 rounded-md px-4 h-11 transition w-full";

  return (
    <>
      <button type="button" onClick={onClick} data-testid="fitment-help-btn" className={`${base} ${className}`}>
        <HelpCircle size={16} /> Need Help Finding The Correct Part?
      </button>
      {open && <FitmentAssistModal prefill={prefill} onClose={() => setOpen(false)} />}
    </>
  );
}
